import type { LucideIcon } from 'lucide-react';
import {
  Apple,
  Armchair,
  Baby,
  Backpack,
  Bandage,
  Battery,
  Bean,
  Bed,
  Beef,
  Beer,
  Bike,
  Book,
  BottleWine,
  Boxes,
  Briefcase,
  Brush,
  Building2,
  Bus,
  Cake,
  Calculator,
  Camera,
  Carrot,
  Candy,
  CandyCane,
  Car,
  ChefHat,
  Cherry,
  Cigarette,
  Citrus,
  Coffee,
  Compass,
  Construction,
  Container,
  Cookie,
  Croissant,
  Cross,
  CupSoda,
  Dog,
  Donut,
  Droplets,
  Drumstick,
  Egg,
  EggFried,
  Factory,
  Fan,
  Fish,
  Flame,
  Flower2,
  Footprints,
  Forklift,
  Fuel,
  Gamepad2,
  Gem,
  Gift,
  GlassWater,
  Globe,
  GraduationCap,
  Grape,
  Hammer,
  Ham,
  HardHat,
  Headphones,
  Heart,
  Heater,
  Home,
  Hospital,
  Hotel,
  IceCream,
  Lamp,
  Laptop,
  Leaf,
  LeafyGreen,
  Lightbulb,
  Martini,
  Medal,
  Microwave,
  Milk,
  Monitor,
  Mountain,
  Music,
  Notebook,
  Nut,
  Package,
  PackageOpen,
  Paintbrush,
  Palette,
  Paperclip,
  PartyPopper,
  PawPrint,
  Pen,
  Pill,
  Plane,
  Plug,
  Popcorn,
  Printer,
  Refrigerator,
  Router,
  Ruler,
  Salad,
  Sandwich,
  Scissors,
  Ship,
  Shirt,
  ShoppingBag,
  ShoppingCart,
  ShowerHead,
  Smartphone,
  Snowflake,
  Sofa,
  Soup,
  Sparkles,
  SprayCan,
  Sprout,
  Stethoscope,
  Store,
  Sun,
  Syringe,
  Tag,
  Tent,
  Toilet,
  Train,
  TreePine,
  Trophy,
  Truck,
  Tv,
  Umbrella,
  Utensils,
  UtensilsCrossed,
  Warehouse,
  Watch,
  Wheat,
  Wine,
  Wrench,
  Zap,
  Glasses,
  Cat,
  SoapDispenserDroplet,
  WashingMachine,
} from 'lucide-react';

export interface CategoryIconDefinition {
  key: string;
  label: string;
  color: string;
  Icon: LucideIcon;
}

export interface CategoryIconGroup {
  id: string;
  label: string;
  icons: CategoryIconDefinition[];
}

/** Eski Font Awesome benzeri anahtarlar → Lucide anahtarları */
export const LEGACY_ICON_ALIASES: Record<string, string> = {
  'apple-alt': 'apple',
  'drumstick-bite': 'drumstick',
  seedling: 'sprout',
  cheese: 'milk',
  'wine-glass': 'wine',
  broom: 'sparkles',
  'box-open': 'package-open',
  'bread-slice': 'croissant',
};

export const CATEGORY_ICON_GROUPS: CategoryIconGroup[] = [
  {
    id: 'food',
    label: 'Gıda & Market',
    icons: [
      { key: 'apple', label: 'Meyve', color: '#22c55e', Icon: Apple },
      { key: 'carrot', label: 'Sebze', color: '#f97316', Icon: Carrot },
      { key: 'cherry', label: 'Kuru Meyve', color: '#ef4444', Icon: Cherry },
      { key: 'citrus', label: 'Turunçgil', color: '#eab308', Icon: Citrus },
      { key: 'grape', label: 'Üzüm', color: '#8b5cf6', Icon: Grape },
      { key: 'leafy-green', label: 'Yeşillik', color: '#16a34a', Icon: LeafyGreen },
      { key: 'salad', label: 'Salata', color: '#84cc16', Icon: Salad },
      { key: 'drumstick', label: 'Et & Tavuk', color: '#dc2626', Icon: Drumstick },
      { key: 'beef', label: 'Kırmızı Et', color: '#b91c1c', Icon: Beef },
      { key: 'fish', label: 'Balık & Deniz', color: '#0284c7', Icon: Fish },
      { key: 'ham', label: 'Şarküteri', color: '#f43f5e', Icon: Ham },
      { key: 'egg', label: 'Yumurta', color: '#fbbf24', Icon: Egg },
      { key: 'egg-fried', label: 'Kahvaltılık', color: '#f59e0b', Icon: EggFried },
      { key: 'milk', label: 'Süt Ürünleri', color: '#fde047', Icon: Milk },
      { key: 'croissant', label: 'Unlu Mamül', color: '#d97706', Icon: Croissant },
      { key: 'sandwich', label: 'Sandviç', color: '#ca8a04', Icon: Sandwich },
      { key: 'cookie', label: 'Atıştırmalık', color: '#a16207', Icon: Cookie },
      { key: 'cake', label: 'Pastane', color: '#ec4899', Icon: Cake },
      { key: 'donut', label: 'Tatlı', color: '#db2777', Icon: Donut },
      { key: 'wheat', label: 'Tahıl & Un', color: '#ca8a04', Icon: Wheat },
      { key: 'bean', label: 'Bakliyat', color: '#78716c', Icon: Bean },
      { key: 'nut', label: 'Kuruyemiş', color: '#92400e', Icon: Nut },
      { key: 'soup', label: 'Konserve', color: '#64748b', Icon: Soup },
      { key: 'popcorn', label: 'Cips & Snack', color: '#facc15', Icon: Popcorn },
      { key: 'candy', label: 'Şekerleme', color: '#e879f9', Icon: Candy },
      { key: 'candy-cane', label: 'Şeker', color: '#f472b6', Icon: CandyCane },
      { key: 'ice-cream', label: 'Dondurma', color: '#38bdf8', Icon: IceCream },
      { key: 'snowflake', label: 'Donmuş Gıda', color: '#0ea5e9', Icon: Snowflake },
      { key: 'sprout', label: 'Kuru Gıda', color: '#059669', Icon: Sprout },
      { key: 'leaf', label: 'Organik', color: '#10b981', Icon: Leaf },
      { key: 'flame', label: 'Baharat', color: '#ef4444', Icon: Flame },
    ],
  },
  {
    id: 'beverage',
    label: 'İçecekler',
    icons: [
      { key: 'wine', label: 'Alkollü İçecek', color: '#7c3aed', Icon: Wine },
      { key: 'bottle-wine', label: 'Şarap', color: '#6d28d9', Icon: BottleWine },
      { key: 'beer', label: 'Bira', color: '#d97706', Icon: Beer },
      { key: 'martini', label: 'Kokteyl', color: '#a855f7', Icon: Martini },
      { key: 'cup-soda', label: 'Gazlı İçecek', color: '#06b6d4', Icon: CupSoda },
      { key: 'glass-water', label: 'Su', color: '#3b82f6', Icon: GlassWater },
      { key: 'coffee', label: 'Kahve & Çay', color: '#78350f', Icon: Coffee },
      { key: 'droplets', label: 'Meyve Suyu', color: '#f97316', Icon: Droplets },
    ],
  },
  {
    id: 'cleaning',
    label: 'Temizlik & Hijyen',
    icons: [
      { key: 'sparkles', label: 'Temizlik', color: '#0ea5e9', Icon: Sparkles },
      { key: 'spray-can', label: 'Deterjan', color: '#0284c7', Icon: SprayCan },
      { key: 'brush', label: 'Süpürge & Fırça', color: '#6366f1', Icon: Brush },
      { key: 'soap-dispenser-droplet', label: 'Sabun & Hijyen', color: '#14b8a6', Icon: SoapDispenserDroplet },
      { key: 'washing-machine', label: 'Çamaşır', color: '#64748b', Icon: WashingMachine },
      { key: 'toilet', label: 'Tuvalet & Banyo', color: '#94a3b8', Icon: Toilet },
      { key: 'shower-head', label: 'Banyo Ürünleri', color: '#38bdf8', Icon: ShowerHead },
      { key: 'paperclip', label: 'Kağıt & Peçete', color: '#cbd5e1', Icon: Paperclip },
    ],
  },
  {
    id: 'personal',
    label: 'Kişisel Bakım',
    icons: [
      { key: 'heart', label: 'Kişisel Bakım', color: '#f43f5e', Icon: Heart },
      { key: 'scissors', label: 'Kuaför', color: '#64748b', Icon: Scissors },
      { key: 'pill', label: 'Eczane', color: '#22c55e', Icon: Pill },
      { key: 'baby', label: 'Bebek', color: '#fb7185', Icon: Baby },
      { key: 'paintbrush', label: 'Kozmetik', color: '#ec4899', Icon: Paintbrush },
      { key: 'cigarette', label: 'Tütün', color: '#78716c', Icon: Cigarette },
    ],
  },
  {
    id: 'fashion',
    label: 'Giyim & Moda',
    icons: [
      { key: 'shirt', label: 'Giyim', color: '#6366f1', Icon: Shirt },
      { key: 'footprints', label: 'Ayakkabı', color: '#475569', Icon: Footprints },
      { key: 'glasses', label: 'Aksesuar', color: '#334155', Icon: Glasses },
      { key: 'watch', label: 'Saat', color: '#1e293b', Icon: Watch },
      { key: 'gem', label: 'Mücevher', color: '#a855f7', Icon: Gem },
      { key: 'briefcase', label: 'Çanta', color: '#92400e', Icon: Briefcase },
      { key: 'backpack', label: 'Spor Çanta', color: '#2563eb', Icon: Backpack },
    ],
  },
  {
    id: 'home',
    label: 'Ev & Yaşam',
    icons: [
      { key: 'home', label: 'Ev', color: '#f97316', Icon: Home },
      { key: 'sofa', label: 'Mobilya', color: '#b45309', Icon: Sofa },
      { key: 'armchair', label: 'Dekorasyon', color: '#d97706', Icon: Armchair },
      { key: 'bed', label: 'Yatak & Tekstil', color: '#6366f1', Icon: Bed },
      { key: 'lamp', label: 'Aydınlatma', color: '#eab308', Icon: Lamp },
      { key: 'refrigerator', label: 'Beyaz Eşya', color: '#64748b', Icon: Refrigerator },
      { key: 'microwave', label: 'Küçük Ev Aleti', color: '#475569', Icon: Microwave },
      { key: 'heater', label: 'Isıtma', color: '#ef4444', Icon: Heater },
      { key: 'fan', label: 'Soğutma', color: '#38bdf8', Icon: Fan },
      { key: 'flower-2', label: 'Bahçe & Çiçek', color: '#22c55e', Icon: Flower2 },
      { key: 'tree-pine', label: 'Bahçe Malzemesi', color: '#15803d', Icon: TreePine },
      { key: 'umbrella', label: 'Ev Dışı', color: '#0284c7', Icon: Umbrella },
    ],
  },
  {
    id: 'electronics',
    label: 'Elektronik',
    icons: [
      { key: 'smartphone', label: 'Telefon', color: '#1e293b', Icon: Smartphone },
      { key: 'laptop', label: 'Bilgisayar', color: '#334155', Icon: Laptop },
      { key: 'monitor', label: 'Monitör', color: '#475569', Icon: Monitor },
      { key: 'tv', label: 'TV & Ses', color: '#0f172a', Icon: Tv },
      { key: 'camera', label: 'Foto & Kamera', color: '#64748b', Icon: Camera },
      { key: 'headphones', label: 'Kulaklık', color: '#6366f1', Icon: Headphones },
      { key: 'gamepad-2', label: 'Oyun', color: '#7c3aed', Icon: Gamepad2 },
      { key: 'router', label: 'Ağ & Modem', color: '#0284c7', Icon: Router },
      { key: 'plug', label: 'Elektrik', color: '#ef4444', Icon: Plug },
      { key: 'lightbulb', label: 'Ampul', color: '#facc15', Icon: Lightbulb },
      { key: 'battery', label: 'Pil & Enerji', color: '#22c55e', Icon: Battery },
      { key: 'zap', label: 'Elektronik', color: '#eab308', Icon: Zap },
    ],
  },
  {
    id: 'health',
    label: 'Sağlık',
    icons: [
      { key: 'stethoscope', label: 'Medikal', color: '#0ea5e9', Icon: Stethoscope },
      { key: 'syringe', label: 'Sağlık Malzemesi', color: '#0284c7', Icon: Syringe },
      { key: 'bandage', label: 'İlk Yardım', color: '#f87171', Icon: Bandage },
      { key: 'cross', label: 'Eczane', color: '#ef4444', Icon: Cross },
      { key: 'hospital', label: 'Sağlık Kurumu', color: '#dc2626', Icon: Hospital },
    ],
  },
  {
    id: 'pet',
    label: 'Pet Shop',
    icons: [
      { key: 'dog', label: 'Köpek', color: '#d97706', Icon: Dog },
      { key: 'cat', label: 'Kedi', color: '#64748b', Icon: Cat },
      { key: 'paw-print', label: 'Pet Ürünleri', color: '#f97316', Icon: PawPrint },
    ],
  },
  {
    id: 'automotive',
    label: 'Otomotiv & Yapı',
    icons: [
      { key: 'car', label: 'Otomotiv', color: '#1e293b', Icon: Car },
      { key: 'fuel', label: 'Akaryakıt', color: '#ef4444', Icon: Fuel },
      { key: 'bike', label: 'Bisiklet', color: '#22c55e', Icon: Bike },
      { key: 'wrench', label: 'Hırdavat', color: '#64748b', Icon: Wrench },
      { key: 'hammer', label: 'El Aletleri', color: '#78716c', Icon: Hammer },
      { key: 'hard-hat', label: 'İş Güvenliği', color: '#f59e0b', Icon: HardHat },
      { key: 'construction', label: 'İnşaat', color: '#ea580c', Icon: Construction },
      { key: 'factory', label: 'Endüstriyel', color: '#475569', Icon: Factory },
      { key: 'forklift', label: 'Depo Ekipmanı', color: '#334155', Icon: Forklift },
    ],
  },
  {
    id: 'office',
    label: 'Ofis & Kırtasiye',
    icons: [
      { key: 'book', label: 'Kitap', color: '#6366f1', Icon: Book },
      { key: 'pen', label: 'Kırtasiye', color: '#0284c7', Icon: Pen },
      { key: 'notebook', label: 'Defter', color: '#0ea5e9', Icon: Notebook },
      { key: 'printer', label: 'Yazıcı', color: '#475569', Icon: Printer },
      { key: 'calculator', label: 'Hesap Makinesi', color: '#64748b', Icon: Calculator },
      { key: 'ruler', label: 'Okul Malzemesi', color: '#94a3b8', Icon: Ruler },
      { key: 'palette', label: 'Sanat Malzemesi', color: '#ec4899', Icon: Palette },
      { key: 'graduation-cap', label: 'Eğitim', color: '#2563eb', Icon: GraduationCap },
    ],
  },
  {
    id: 'horeca',
    label: 'HORECA & Toptan',
    icons: [
      { key: 'utensils', label: 'Restoran', color: '#f97316', Icon: Utensils },
      { key: 'utensils-crossed', label: 'Catering', color: '#ea580c', Icon: UtensilsCrossed },
      { key: 'chef-hat', label: 'Profesyonel Mutfak', color: '#ea580c', Icon: ChefHat },
      { key: 'store', label: 'Perakende', color: '#ff6b00', Icon: Store },
      { key: 'building-2', label: 'Kurumsal', color: '#64748b', Icon: Building2 },
      { key: 'hotel', label: 'Otel & Konaklama', color: '#6366f1', Icon: Hotel },
      { key: 'warehouse', label: 'Depo', color: '#475569', Icon: Warehouse },
      { key: 'truck', label: 'Lojistik', color: '#334155', Icon: Truck },
      { key: 'container', label: 'Konteyner', color: '#78716c', Icon: Container },
      { key: 'forklift', label: 'Forklift', color: '#1e293b', Icon: Forklift },
    ],
  },
  {
    id: 'leisure',
    label: 'Spor & Eğlence',
    icons: [
      { key: 'trophy', label: 'Spor', color: '#eab308', Icon: Trophy },
      { key: 'medal', label: 'Fitness', color: '#f59e0b', Icon: Medal },
      { key: 'music', label: 'Müzik', color: '#a855f7', Icon: Music },
      { key: 'gift', label: 'Hediye', color: '#ec4899', Icon: Gift },
      { key: 'party-popper', label: 'Parti & Etkinlik', color: '#f472b6', Icon: PartyPopper },
      { key: 'mountain', label: 'Outdoor', color: '#15803d', Icon: Mountain },
      { key: 'tent', label: 'Kamp', color: '#16a34a', Icon: Tent },
      { key: 'compass', label: 'Gezi', color: '#0284c7', Icon: Compass },
      { key: 'sun', label: 'Yaz Sezonu', color: '#facc15', Icon: Sun },
    ],
  },
  {
    id: 'logistics',
    label: 'Ambalaj & Lojistik',
    icons: [
      { key: 'package', label: 'Ambalaj', color: '#78716c', Icon: Package },
      { key: 'package-open', label: 'Koli & Paket', color: '#64748b', Icon: PackageOpen },
      { key: 'boxes', label: 'Kutu', color: '#94a3b8', Icon: Boxes },
      { key: 'shopping-bag', label: 'Poşet', color: '#ff6b00', Icon: ShoppingBag },
      { key: 'shopping-cart', label: 'Market', color: '#ff6b00', Icon: ShoppingCart },
    ],
  },
  {
    id: 'travel',
    label: 'Ulaşım & Turizm',
    icons: [
      { key: 'plane', label: 'Havayolu', color: '#0ea5e9', Icon: Plane },
      { key: 'ship', label: 'Deniz Taşımacılığı', color: '#0284c7', Icon: Ship },
      { key: 'train', label: 'Demiryolu', color: '#475569', Icon: Train },
      { key: 'bus', label: 'Otobüs', color: '#f59e0b', Icon: Bus },
      { key: 'globe', label: 'Turizm', color: '#22c55e', Icon: Globe },
    ],
  },
  {
    id: 'general',
    label: 'Genel',
    icons: [{ key: 'tag', label: 'Genel Kategori', color: '#ff6b00', Icon: Tag }],
  },
];

const iconMap = new Map<string, CategoryIconDefinition>();
for (const group of CATEGORY_ICON_GROUPS) {
  for (const icon of group.icons) {
    if (!iconMap.has(icon.key)) {
      iconMap.set(icon.key, icon);
    }
  }
}

export const CATEGORY_ICON_REGISTRY = iconMap;

export const CATEGORY_ICON_OPTIONS = Array.from(iconMap.keys());

export function normalizeCategoryIconKey(icon?: string | null): string {
  if (!icon) return 'tag';
  const trimmed = icon.trim();
  if (!trimmed) return 'tag';
  const aliased = LEGACY_ICON_ALIASES[trimmed] ?? trimmed;
  return iconMap.has(aliased) ? aliased : 'tag';
}
